export default ({ request }) => ({

  detailDesignElementsInputTemplateApi(data) {
    return request({
      url: '/digitalCenter/designElementsInputTemplate/detail',
      method: 'post',
      data
    })
  },
// 根据素材分类编码查询模板详情接口
  detailByCategoryCodeDesignElementsInputTemplateApi(data) {
    return request({
      url: '/digitalCenter/designElementsInputTemplate/getElementTemByCategoryCode',
      method: 'post',
      data
    })
  },
  listDesignElementsInputTemplateApi(data) {
    return request({
      url: '/digitalCenter/designElementsInputTemplate/list',
      method: 'post',
      data
    })
  },
  saveDesignElementsInputTemplateApi(data) {
    return request({
      url: '/digitalCenter/designElementsInputTemplate/save',
      method: 'post',
      data
    })
  },
  delDesignElementsInputTemplateApi(data) {
    return request({
      url: '/digitalCenter/designElementsInputTemplate/del',
      method: 'post',
      data
    })
  }
})
